<template>
  <div class="select-container">
    <div class="select-wrapper disp-scroll">
      <section>
        <table class="table-box">
          <tr>
            <th class="table-box-header">
              メッセージ内容
            </th>
          </tr>
          <tr>
            <td>
              <textarea class="textarea main-message disp-scroll"
                :value="scenarioEdit.mainmessage"
                placeholder="例：お名前を入力してください"
                @input="changeMainmessage($event.target.value)"
                :disabled="isDisable() || scenarioEdit.is_confirm">
              </textarea>
            </td>
          </tr>
        </table>
      </section>
      <section>
        <table class="table-box">
          <tr>
            <th class="table-box-header" style="max-width: 64px; width: 64px;">順番</th>
            <th class="table-box-header">選択肢内容</th>
            <th class="table-box-header" style="max-width: 100px; width: 100px;">ポイント</th>
            <th class="table-box-header" style="max-width: 100px; width: 100px;">色</th>
            <th class="table-box-header" style="max-width: 80px; width: 80px;">URL</th>
            <th class="table-box-header" style="max-width: 80px; width: 80px;">削除</th>
          </tr>
          <draggable
            class="select-box"
            :list="scenarioEdit.select"
            @update="setURLItemsIndex()"
            @end="saveSelectOrder(scenarioEdit.select)"
            :options="{
              animation: 300,
              handle: '.drag-button',
              disabled: scenarioEdit.is_confirm
            }"
          >
              <tr v-for="(s, scnIDX) in scenarioEdit.select" :key="scnIDX">
                <td>
                  <button class="button drag-button">
                    <span class="mdi mdi-drag mdi-24px"></span>
                  </button>
                </td>
                <td style="display: flex;">
                  <!-- 選択肢内容 -->
                  <textarea placeholder="ボタン選択肢を入力"
                    :value="s.content"
                    @input="changeBtnMessage($event.target.value, scnIDX)"
                    @compositionstart="compositionstart()"
                    @compositionend="compositionend()"
                    @keydown="handleKeydown($event, s.content)"
                    :disabled="isDisable() || scenarioEdit.is_confirm"
                    class="input select-btn-message">
                  </textarea>
                  <!-- URL入力 -->
                  <input placeholder="URLを入力"
                    class="input"
                    :value="s.url"
                    @input="emitSelectInput('change-btn-url', $event.target.value, scnIDX)"
                    :id="'modal_input-' + scnIDX"
                    v-if="isUrl(scnIDX)"
                    :disabled="isDisable() || scenarioEdit.is_confirm">
                  </input>
                </td>
                <td>
                  <!-- ポイント設定 -->
                  <input class="input point-input"
                    step="1"
                    type="number"
                    :value="s.point"
                    @input="emitSelectInput('change-btn-point', $event.target.value, scnIDX)"
                    :disabled="isDisable() || scenarioEdit.is_confirm"/>
                </td>
                <td>
                  <!-- 色設定 -->
                  <b-select placeholder="色"
                    v-model="s.text_option"
                    :disabled="isDisable() || scenarioEdit.is_confirm">
                    <option v-for="(color, colorNum) in buttonColors" :value="color" :key="colorNum">
                      {{color}}
                    </option>
                  </b-select>
                </td>
                <td>
                  <!-- URL表示ボタン -->
                  <button class="button"
                    :class="{ on_switch: isUrl(scnIDX) }" 
                    @click="clickUrl(s)"
                    :id="['url_btn-' + scnIDX]"
                    :disabled="isDisable() || scenarioEdit.is_confirm">
                    {{isUrl(scnIDX) ? 'ON' : 'OFF'}}
                  </button>
                </td>
                <td>
                  <!-- 削除ボタン -->
                  <button class="button delete-button"
                    @click="delSelect(scnIDX)"
                    v-if="scenarioEdit.select.length > 1"
                    :disabled="isDisable() || scenarioEdit.is_confirm">
                    <span class="mdi mdi-close"></span>
                  </button>
                </td>
              </tr>
          </draggable>
        </table>
      </section>
      <section>
        <div v-if="scenarioEdit.select.length < 10 && scenarioEdit.status===0">
          <button class="button is-fullwidth"
            @click="addSelect('')"
            :disabled="isDisable() || scenarioEdit.is_confirm">
            <i class="mdi mdi-plus-box"></i>
            ボタン追加
          </button>
        </div>
      </section>
      <section>
        <table class="table-box">
          <tr>
            <th class="table-box-header">
              設定項目
            </th>
          </tr>
          <tr>
            <td>
              <b-select class="select colomn-name"
                style="width: 100%;"
                placeholder="詳細項目"
                v-model="scenarioEdit.company_column"
                :disabled="filteredCustomColumns.length <= 0 || isColumnLoading || scenarioEdit.is_confirm"
                expanded>
                  <option value=""></option>
                  <option
                    v-for="(comCol, idx) in filteredCustomColumns"
                    :value="comCol"
                    :key="idx + '-comCol'">
                    {{getCustomName(comCol)}}
                  </option>
              </b-select>
            </td>
          </tr>
        </table>
      </section>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
export default {
  props: {
    scenarioEdit: {
      type: Object,
    },
  },
  components: {
    draggable
  },
  data () {
    return {
      buttonColors: [
        'White',
        'Blue',
        'Yellow',
        'Red'
      ],
      isColumnLoading: false,
      companyColumns: [],
      composing: false,
      urlItemsIndex: []
    }
  },
  computed: {
    filteredCustomColumns () {
      let sortedColumns = this.companyColumns.sort((a, b) => {
        if (a.order_type < b.order_type) return -1
        if (a.order_type > b.order_type) return 1
        return 0
      })
      return this.$_.map(
        this.$_.filter(
          sortedColumns,
          ((obj) => {
            return obj.template_type === 0
          })
        ),
        this.$_.property('pk')
      )
    }
  },
  created () {
    this.isColumnLoading = true
    this.$store.dispatch('auth/getCompanyColumnSetting', null)
      .then((data) => {
        this.companyColumns = data
        this.isColumnLoading = false
      })
    this.setURLItemsIndex()
  },
  watch: {
    scenarioEdit () {
      this.setURLItemsIndex()
    }
  },
  methods: {
    getCustomName (pk) {
      return this.companyColumns[
        this.$_.findIndex(
          this.companyColumns,
          ((obj) => {return obj.pk === pk})
        )
      ].name
    },
    clickUrl (s) {
      this.$emit('click-url', s)
      this.setURLItemsIndex()
    },
    isUrl (idx) {
      return this.urlItemsIndex.includes(idx)
    },
    setURLItemsIndex () {
      this.urlItemsIndex = []
      for (const i in this.scenarioEdit.select) {
        if (this.scenarioEdit.select[i].url !== undefined) this.urlItemsIndex.push(Number(i))
      }
    },
    addSelect (v) {
      this.$emit('add-select', v)
    },
    delSelect (idx) {
      this.$emit('del-select', idx)
      this.setURLItemsIndex()
    },
    isDisable(){
      this.$emit('is-disable')
    },
    changeMainmessage (event) {
      this.$emit('change-mainmessage', event)
    },
    changeBtnMessage (value, index) {
      const selects = value.split('\n')
      this.$emit('change-btn-message', selects[0], index)
      let selectLength = this.scenarioEdit.select.length
      for (const i in selects) {
        if (i >= 1 &&  selectLength < 10 && selects[i] !== '') {
          selectLength++
          this.addSelect(selects[i])
        }
      }
    },
    handleKeydown(event, v) {
      if (this.composing) return // IME対応(日本語変換中のEnterを止める)
      if (event.key === 'Enter') document.activeElement.blur()
    },
    emitSelectInput (emitName, value, index) {
      this.$emit(emitName, value, index)
    },
    compositionstart () {
      this.composing = true
    },
    compositionend () {
      this.composing = false
    },
    saveSelectOrder (temp) {
      for (let i in temp) {
        let tempOrder = temp[i]
        tempOrder.order_type = Number(i)
        this.scenarioEdit.select.splice(i, 1, tempOrder)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.select-container {
  height: 500px;
  .on_switch {
    color:#a22;
  }
  .select-wrapper {
    height: 500px;
    background-color: white;
    .-title {
      font-size: 16px;
      padding: 16px;
      text-align: center;
    }
    section {
      text-align: left;
    }
    section:not(:first-child) {
      margin-top: 24px;
    }
  }
  .table-box {
    width: 100%;
    button, input, select {
      width: 100%;
      background: transparent !important;
    }
    .drag-button {
      border: solid thin #ccc !important;
    }
    .select-box {
      width: max-content;
      display: contents;
    }
  }
  .table-box-header {
    border: solid thin #ccc !important;
    background: rgb(250, 230, 230) !important;
    color: #222;
    padding: 8px !important;
    text-align: center;
  }
  .message-content {
    margin-top: 8px;
  }
  .point-input {
    width: 80px;
  }
  .delete-button {
    background: #f8f8f8;
  }
  /* ポイント入力の際勝手に動くバグがあるため、手動入力に変更 */
  input[type='number']::-webkit-outer-spin-button,
  input[type='number']::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance:textfield;
  }
  input::-ms-clear {
    visibility:hidden
  }
  .select-btn-message {
    resize: none;
    padding-top: 8px;
    padding-left: 8px;
    border-radius: 4px;
    border-color: #ccc;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/chatbot/modals/ModalEditSelectParts.vue